export default __webpack_public_path__ + "static/media/NW0220.34I-42972_-25678_0.0cbdcb50.jpg";